import React from 'react';
import MaterialSelect from './materialSelect';
import SaunaImageContainer from '../containers/SaunaImageContainer';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import localization from '../helpers/localization.js';
import { contentRoot } from '../config.js';


const SelectBenchShapePage = ({
    selections,
    unavailableSelections,
    onChange,
    selected,
    showPrices,
    prices,
    selectionName,
    nextPage,
    prevPage,
    mirrorBench,
    mirrored,
    canMirrorBench }) => {
    return (<div className="page">
        <SaunaImageContainer />        
        <div className="materialSelections">            
            <Row>
                <Col md={12} sm={12}><MaterialSelect mirrored={mirrored} columnNum={4} materials={selections} autoAdjustWidth={true} onChange={onChange} header={selectionName} selected={selected} showPrices={showPrices} prices={prices} />
                </Col>
            </Row>
            {unavailableBenchSelections(unavailableSelections, mirrored)}
            {mirrorBenchButtom(canMirrorBench, mirrorBench)}            
            <div className="changePhaseRow">
                <span className="orangeButton changePhaseButton" onClick={() => { prevPage() }}> <span className="buttonTxt">&#8592;  {localization.prevPhase}</span></span>
                <span className="orangeButton changePhaseButton" onClick={() => { nextPage() }}> <span className="buttonTxt"> {localization.nextPhase} &#8594;</span></span>
            </div>
        </div>
    </div>
    )
}
export default SelectBenchShapePage

let unavailableBenchSelections = (selections, mirrored) => {
    if (!selections || selections.length === 0) return "";

    return (<div className="unavailableBenchSelections">
        <h2>{localization.unavailableBenchShapes}</h2>
        <div className="unavailableBenchSelectionInfo">{localization.unavailableBenchShapesInfo}</div>
        <div className="materialRow">
            {selections.map(selection => unavailableBenchSelection(selection, mirrored))}
        </div>
    </div>);
}

let unavailableBenchSelection = (selection, mirrored) => {
    let thumbnailStyle = {};
    if (mirrored) {
        thumbnailStyle.transform = "scaleX(-1)";
    }
    return (<div className="materialOption unavailableBenchOption" key={selection.id}>
        <img style={thumbnailStyle} src={contentRoot + selection.thumbnail} alt={selection.name}></img>
        <div className="unavailableBenchOverlay">
            <strong>{localization[selection.localizationResourceName] ? localization[selection.localizationResourceName] : selection.name}</strong>
            <span>{selection.fitReason}</span>
        </div>
    </div>);
}

let mirrorBenchButtom = (canMirrorBench, mirrorBench) => {
    if (canMirrorBench) {
        return (<div className="modelSelectionButtonBar clearfix alingCenter" style={{ marginBottom: "10px" }}>
            <span className="selectModelBtn" onClick={mirrorBench}>
                <span className="buttonTxt">{localization.changeHandedness}</span>
            </span>
        </div>);
    }
    else return "";
}
